import React, { useRef, useEffect, useState } from "react";

const { innerWidth: _width, innerHeight: _height } = window;

export const MapSVG = ({ setTooltipParams, locations, setActive }) => {
  const [cirlceRadius, setCirlceRadius] = useState(29);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (_width <= 724) {
      setCirlceRadius(49);
      setIsMobile(true);
    }
  }, [_width]);

  if (isMobile) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="main-map"
        viewBox="0 0 2553 1942"
        fill="none"
      >
        <g id="map">
          <path
            id="Arizona"
            d="M1632.38 976.326L1482.14 979.029L1401.23 978.967L1285.64 977.147L1274 977.021L1274.13 977.901L1267.1 1065.98L1256.96 1066.98L1239.68 1055.55L1222.74 1074.59L1232.33 1144.57L1227.47 1160.53L1227.66 1161.85L1227.72 1162.29L1228.42 1173.41L1249.68 1212.54L1265.91 1229.07L1243.46 1247.1L1236.42 1266.51L1226.2 1307.47L1218.57 1310.36L1222.74 1342.52L1237.76 1350.69L1233.53 1371.05L1217.89 1374.19L1211.15 1392.66L1245.53 1407.92L1309.88 1432.8L1507.9 1504.48L1666.59 1501.46L1668.34 1501.21L1662 1369.72L1660.46 1337.18L1644.48 992.095L1643.96 976.012L1632.38 976.326Z"
            fill="url(#paint0_linear_34_304)"
          />
          <path
            id="New Mexico"
            d="M2095.88 979.05L2094.68 967.571L2093.48 956.092L2092.29 944.613L2078.17 946.19L1980.45 955.726L1882.05 963.568L1657.88 976.009L1644.08 976.645L1644.59 992.704L1660.39 1337.27L1661.92 1369.77L1668.2 1501.06L1670.02 1501.24L1731.46 1498.26L1732.76 1466.7L1742.48 1456.34L1867.05 1449.68L1867.93 1449.55L1853.86 1429.61L1910.22 1425.56L2050.6 1413.49L2138.15 1404.96L2094 990.97L2097.14 990.968L2095.88 979.05Z"
            fill="url(#paint1_linear_34_304)"
          />
          <path
            id="New Mexico_2"
            d="M2122.88 961.05L2121.68 949.571L2120.48 938.092L2119.29 926.613L2105.17 928.19L2007.45 937.726L1909.05 945.568L1684.88 958.009L1671.08 958.645L1671.59 974.704L1687.39 1319.27L1688.92 1351.77L1695.2 1483.06L1697.02 1483.24L1758.46 1480.26L1759.76 1448.7L1769.48 1438.34L1894.05 1431.68L1894.93 1431.55L1880.86 1411.61L1937.22 1407.56L2077.6 1395.49L2165.15 1386.96L2121 972.97L2124.14 972.968L2122.88 961.05Z"
            fill="url(#paint2_linear_34_304)"
            stroke="url(#paint3_linear_34_304)"
            stroke-width="4"
            stroke-linejoin="round"
          />
          <path
            id="California"
            d="M913.739 1328.06L916.883 1337.47L917.135 1339.23L913.739 1328.06ZM843.729 1299.54L847.75 1305.69L849.445 1304.99L843.729 1299.54ZM920.432 1287.19L923.389 1298.42L932.117 1303L920.432 1287.19ZM858.317 1232.42L853.294 1231.8L857.501 1232.99L858.317 1232.42ZM807.654 1226.24L796.799 1234.97L800.316 1237.61L807.654 1226.24ZM783.609 1221.17L783.234 1224.81L787.315 1225.12L783.609 1221.17ZM823.535 1224.41L844.444 1232.62L847.517 1229.04L823.535 1224.41ZM665.506 854.269L664.877 853.014L665.129 854.771L665.506 854.269ZM871.192 484.417L853.425 482.481L657.932 457.612L585.044 446.544L585.296 448.302L587.582 492.367L576.502 546.421L551.229 589.058L553.123 608.517L571.907 633.175L584.419 667.253L577.97 697.325L583.825 725.633L580.254 738.252L603.878 774.772L617.445 788.072L622.68 830.817L653.641 852.832L665.677 824.201L684.767 835.363L690.475 828.266L667.379 836.064L670.154 858.535L679.021 885.961L664.011 875.11L654.084 859.046L655.29 883.087L668.186 929.218L697.14 956.005L683.908 979.427L690.389 1005.85L711.873 1030.57L754.731 1110.52L765.154 1114.4L770.461 1173.28L776.302 1179.62L845.614 1193.89L868.914 1212.52L877.961 1225.57L898.869 1233.78L920.527 1234.71L932.781 1257.62L951.554 1263.44L982.392 1290.86L1012.86 1328.19L1016.52 1366.23L1032.73 1382.29L1214.96 1374.08L1230.65 1370.93L1234.91 1350.59L1219.83 1342.44L1215.67 1310.3L1223.33 1307.41L1233.6 1266.48L1240.68 1247.08L1263.21 1229.05L1246.94 1212.55L1225.64 1173.45L1224.94 1162.34L1224.88 1161.9L1211.25 1148.16L1169.35 1106.19L1087.51 1020.18L973.063 897.59L908.806 831.026L846.244 763.77L869.632 501.68L871.192 484.417Z"
            fill="url(#paint4_linear_34_304)"
          />
          <path
            id="Arizona_2"
            d="M1659.76 960.022L1509.51 962.725L1428.6 962.663L1313.02 960.843L1301.38 960.717L1301.5 961.597L1294.47 1049.67L1284.34 1050.68L1267.05 1039.25L1250.12 1058.28L1259.71 1128.27L1254.84 1144.22L1255.03 1145.54L1255.1 1145.98L1255.8 1157.1L1277.06 1196.24L1293.28 1212.76L1270.84 1230.79L1263.79 1250.2L1253.57 1291.16L1245.94 1294.05L1250.11 1326.22L1265.14 1334.39L1260.91 1354.74L1245.27 1357.88L1238.53 1376.35L1272.9 1391.62L1337.26 1416.5L1535.27 1488.17L1693.97 1485.16L1695.72 1484.91L1689.37 1353.42L1687.83 1320.88L1671.85 975.791L1671.33 959.708L1659.76 960.022Z"
            fill="url(#paint5_linear_34_304)"
            stroke="url(#paint6_linear_34_304)"
            stroke-width="4"
            stroke-linejoin="round"
          />
          <g id="California_2">
            <path
              d="M943.739 1312.06L946.883 1321.47L947.135 1323.23L943.739 1312.06ZM873.729 1283.54L877.75 1289.69L879.445 1288.99L873.729 1283.54ZM950.432 1271.19L953.389 1282.42L962.117 1287L950.432 1271.19ZM888.317 1216.42L883.294 1215.8L887.501 1216.99L888.317 1216.42ZM837.654 1210.24L826.799 1218.97L830.316 1221.61L837.654 1210.24ZM813.609 1205.17L813.234 1208.81L817.315 1209.12L813.609 1205.17ZM853.535 1208.41L874.444 1216.62L877.517 1213.04L853.535 1208.41ZM695.506 838.269L694.877 837.014L695.129 838.771L695.506 838.269ZM901.192 468.417L883.425 466.481L687.932 441.612L615.044 430.544L615.296 432.302L617.582 476.367L606.502 530.421L581.229 573.058L583.123 592.517L601.907 617.175L614.419 651.253L607.97 681.325L613.825 709.633L610.254 722.252L633.878 758.772L647.445 772.072L652.68 814.817L683.641 836.832L695.677 808.201L714.767 819.363L720.475 812.266L697.379 820.064L700.154 842.535L709.021 869.961L694.011 859.11L684.084 843.046L685.29 867.087L698.186 913.218L727.14 940.005L713.908 963.427L720.389 989.85L741.873 1014.57L784.731 1094.52L795.154 1098.4L800.461 1157.28L806.302 1163.62L875.614 1177.89L898.914 1196.52L907.961 1209.57L928.869 1217.78L950.527 1218.71L962.781 1241.62L981.554 1247.44L1012.39 1274.86L1042.86 1312.19L1046.52 1350.23L1062.73 1366.29L1244.96 1358.08L1260.65 1354.93L1264.91 1334.59L1249.83 1326.44L1245.67 1294.3L1253.33 1291.41L1263.6 1250.48L1270.68 1231.08L1293.21 1213.05L1276.94 1196.55L1255.64 1157.45L1254.94 1146.34L1254.88 1145.9L1241.25 1132.16L1199.35 1090.19L1117.51 1004.18L1003.06 881.59L938.806 815.026L876.244 747.77L899.632 485.68L901.192 468.417Z"
              fill="url(#paint7_linear_34_304)"
            />
            <path
              d="M648.177 842.816L647.8 843.319M943.739 1312.06L946.883 1321.47L947.135 1323.23L943.739 1312.06ZM873.729 1283.54L877.75 1289.69L879.445 1288.99L873.729 1283.54ZM950.432 1271.19L953.389 1282.42L962.117 1287L950.432 1271.19ZM888.317 1216.42L883.294 1215.8L887.501 1216.99L888.317 1216.42ZM837.654 1210.24L826.799 1218.97L830.316 1221.61L837.654 1210.24ZM813.609 1205.17L813.234 1208.81L817.315 1209.12L813.609 1205.17ZM853.535 1208.41L874.444 1216.62L877.517 1213.04L853.535 1208.41ZM695.506 838.269L694.877 837.014L695.129 838.771L695.506 838.269ZM901.192 468.417L883.425 466.481L687.932 441.612L615.044 430.544L615.296 432.302L617.582 476.367L606.502 530.421L581.229 573.058L583.123 592.517L601.907 617.175L614.419 651.253L607.97 681.325L613.825 709.633L610.254 722.252L633.878 758.772L647.445 772.072L652.68 814.817L683.641 836.832L695.677 808.201L714.767 819.363L720.475 812.266L697.379 820.064L700.154 842.535L709.021 869.961L694.011 859.11L684.084 843.046L685.29 867.087L698.186 913.218L727.14 940.005L713.908 963.427L720.389 989.85L741.873 1014.57L784.731 1094.52L795.154 1098.4L800.461 1157.28L806.302 1163.62L875.614 1177.89L898.914 1196.52L907.961 1209.57L928.869 1217.78L950.527 1218.71L962.781 1241.62L981.554 1247.44L1012.39 1274.86L1042.86 1312.19L1046.52 1350.23L1062.73 1366.29L1244.96 1358.08L1260.65 1354.93L1264.91 1334.59L1249.83 1326.44L1245.67 1294.3L1253.33 1291.41L1263.6 1250.48L1270.68 1231.08L1293.21 1213.05L1276.94 1196.55L1255.64 1157.45L1254.94 1146.34L1254.88 1145.9L1241.25 1132.16L1199.35 1090.19L1117.51 1004.18L1003.06 881.59L938.806 815.026L876.244 747.77L899.632 485.68L901.192 468.417Z"
              stroke="url(#paint8_linear_34_304)"
              stroke-width="4"
              stroke-linejoin="round"
            />
          </g>
          <path
            id="Colorado"
            d="M2156.31 638.253L2145.73 551.955L2124.5 554.103L2016.7 565.536L2006.08 566.61L1997.23 567.432L1865.5 577.816L1777.47 583.276L1667.4 588.312L1656.66 588.508L1656.98 600.112L1666.06 832.24L1669.17 913.337L1670.63 948.524L1671.38 960.064L1685.2 959.426L1909.48 946.966L2007.94 939.115L2105.7 929.572L2119.83 927.993L2128.68 927.172L2147.2 924.963L2156.06 924.141L2183.87 921.047L2190.9 920.038L2189.64 911.258L2161.16 678.329L2157.89 652.364L2156.69 644.023L2156.31 638.253Z"
            fill="url(#paint9_linear_34_304)"
            stroke="url(#paint10_linear_34_304)"
            stroke-width="4"
            stroke-linejoin="round"
          />
          <path
            id="Nevada"
            d="M1301.67 947.213L1306.58 656.414L1309.45 510.731L1310.07 496.294L1297.01 495.925L1246.05 493.821L1118.18 487.054L1105.5 486.183L1092.83 485.312L1028.93 480.579L913.993 470.164L901.25 468.853L899.691 486.115L876.306 748.178L938.861 815.427L1003.11 881.985L1117.54 1004.56L1199.38 1090.57L1241.27 1132.54L1254.9 1146.27L1254.71 1144.95L1259.6 1129.01L1250.01 1059.09L1267.01 1040.07L1284.34 1051.48L1294.51 1050.47L1301.62 962.466L1301.49 961.587L1301.67 947.213Z"
            fill="url(#paint11_linear_34_304)"
            stroke="url(#paint12_linear_34_304)"
            stroke-width="4"
            stroke-linejoin="round"
          />
          <path
            id="Utah"
            d="M1502.65 498.312L1386.95 497.409L1322.29 496.363L1309.69 495.927L1309.07 510.375L1306.24 656.175L1301.41 947.208L1301.23 961.594L1312.89 961.715L1428.72 963.498L1509.81 963.534L1660.37 960.783L1671.97 960.465L1671.21 948.907L1669.74 913.667L1666.6 832.445L1657.44 599.962L1657.11 588.341L1648.21 588.721L1534.33 591.146L1516.9 591.403L1515.57 504.087L1515.63 498.245L1502.65 498.312Z"
            fill="url(#paint13_linear_34_304)"
            stroke="url(#paint14_linear_34_304)"
            stroke-width="4"
            stroke-linejoin="round"
          />
          <g id="grid-line" filter="url(#filter0_dddddd_34_304)">
            <path
              d="M1873.5 679.5L680 726.6L931.5 1181.5L993.5 1210L1046 1262.5L1873.5 679.5Z"
              stroke="#00CFDD"
              stroke-width="4"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-dasharray="20 20"
              className="dash"
            />
          </g>
          <g
            id="ventura-1"
            filter="url(#filter1_dddddd_34_304)"
            onMouseEnter={(e) => {
              setTooltipParams({
                x: e.pageX,
                y: e.pageY,
                site: "3216399",
                mouseOnLoc: true,
                api_key: "XVRME06UVZZ8Z4YSKDOLAWPN0QPEUF41",
                location: locations[1],
              });
            }}
            onMouseLeave={() =>
              setTooltipParams((ps) => ({ ...ps, mouseOnLoc: false }))
            }
            onClick={() => setActive(locations[1])}
          >
            <circle cx="931" cy="1155" r="50" fill="#3D3D56" />
          </g>
          <g
            id="ventura-2"
            filter="url(#filter2_dddddd_34_304)"
            onMouseEnter={(e) => {
              setTooltipParams({
                x: e.pageX,
                y: e.pageY,
                site: "2140795",
                mouseOnLoc: true,
                api_key: "TAIZZC11OHF8SR4RIA3KYLM1NZ4Y7U6T",
                location: locations[2],
              });
            }}
            onMouseLeave={() =>
              setTooltipParams((ps) => ({ ...ps, mouseOnLoc: false }))
            }
            onClick={() => setActive(locations[2])}
          >
            <ellipse
              cx="1003.86"
              cy="1216"
              rx="50.8621"
              ry="50"
              fill="#3D3D56"
            />
          </g>
          <g
            id="malibu"
            filter="url(#filter3_dddddd_34_304)"
            onMouseEnter={(e) => {
              setTooltipParams({
                x: e.pageX,
                y: e.pageY,
                site: "2048560",
                mouseOnLoc: true,
                api_key: "P1GNDFIMMHTOL883T16PQSYS8ILLRE5J",
                location: locations[0],
              });
            }}
            onMouseLeave={() =>
              setTooltipParams((ps) => ({ ...ps, mouseOnLoc: false }))
            }
            onClick={() => setActive(locations[0])}
          >
            <ellipse
              cx="1085.86"
              cy="1290"
              rx="50.8621"
              ry="50"
              fill="#3D3D56"
            />
          </g>
          <g
            id="colorado"
            filter="url(#filter4_dddddd_34_304)"
            onMouseEnter={(e) => {
              setTooltipParams({
                x: e.pageX,
                y: e.pageY,
                site: "1639176",
                mouseOnLoc: true,
                api_key: "KW0CIBOR7XLQX6CYFNJHHL5NMRHJYMN8",
                location: locations[5],
              });
            }}
            onMouseLeave={() =>
              setTooltipParams((ps) => ({ ...ps, mouseOnLoc: false }))
            }
            onClick={() => setActive(locations[5])}
          >
            <ellipse
              cx="1870.86"
              cy="681"
              rx="50.8621"
              ry="50"
              fill="#3D3D56"
            />
          </g>
          <path
            id="CA"
            d="M908.64 1004.48C905.68 1004.48 903.16 1003.97 901.08 1002.96C899.027 1001.92 897.467 1000.35 896.4 998.24C895.333 996.133 894.8 993.467 894.8 990.24C894.8 985.493 895.987 981.947 898.36 979.6C900.76 977.227 904.187 976.04 908.64 976.04C911.12 976.04 913.32 976.467 915.24 977.32C917.16 978.147 918.653 979.4 919.72 981.08C920.813 982.733 921.36 984.8 921.36 987.28H914.36C914.36 986.107 914.12 985.107 913.64 984.28C913.187 983.427 912.533 982.773 911.68 982.32C910.853 981.867 909.84 981.64 908.64 981.64C907.147 981.64 905.92 981.947 904.96 982.56C904 983.173 903.293 984.053 902.84 985.2C902.387 986.347 902.16 987.733 902.16 989.36V991.16C902.16 992.787 902.387 994.187 902.84 995.36C903.293 996.507 903.987 997.387 904.92 998C905.88 998.587 907.107 998.88 908.6 998.88C909.88 998.88 910.96 998.667 911.84 998.24C912.747 997.813 913.427 997.187 913.88 996.36C914.36 995.507 914.6 994.493 914.6 993.32H921.36C921.36 995.8 920.827 997.867 919.76 999.52C918.72 1001.17 917.24 1002.41 915.32 1003.24C913.427 1004.07 911.2 1004.48 908.64 1004.48ZM922.968 1004L933.288 976.52H941.888L952.208 1004H944.568L942.928 999.24H931.968L930.328 1004H922.968ZM933.688 993.88H941.168L939.208 988.08C939.102 987.787 938.968 987.427 938.808 987C938.675 986.547 938.528 986.08 938.368 985.6C938.235 985.093 938.102 984.587 937.968 984.08C937.835 983.573 937.702 983.133 937.568 982.76H937.288C937.182 983.267 937.022 983.84 936.808 984.48C936.622 985.12 936.422 985.76 936.208 986.4C936.022 987.04 935.848 987.6 935.688 988.08L933.688 993.88Z"
            fill="#292A39"
          />
          <path
            id="NV"
            d="M1078 777V749.52H1084.36L1094.36 762.28C1094.55 762.493 1094.79 762.8 1095.08 763.2C1095.4 763.6 1095.71 764.013 1096 764.44C1096.29 764.84 1096.51 765.16 1096.64 765.4L1096.84 765.36C1096.84 764.773 1096.84 764.213 1096.84 763.68C1096.84 763.12 1096.84 762.653 1096.84 762.28V749.52H1103.48V777H1097.16L1086.56 763.56C1086.21 763.133 1085.88 762.693 1085.56 762.24C1085.27 761.787 1085.03 761.413 1084.84 761.12L1084.64 761.16C1084.64 761.587 1084.64 762.027 1084.64 762.48C1084.64 762.907 1084.64 763.267 1084.64 763.56V777H1078ZM1116.92 777L1107.04 749.52H1114.72L1119.76 765.04C1119.87 765.36 1120 765.787 1120.16 766.32C1120.32 766.827 1120.48 767.36 1120.64 767.92C1120.83 768.453 1120.98 768.933 1121.08 769.36H1121.36C1121.5 768.96 1121.63 768.507 1121.76 768C1121.92 767.467 1122.08 766.947 1122.24 766.44C1122.4 765.907 1122.54 765.453 1122.64 765.08L1127.68 749.52H1135.08L1125.24 777H1116.92Z"
            fill="#292A39"
            fill-opacity="0.25"
          />
          <path
            id="UT"
            d="M1469.64 797.48C1467 797.48 1464.72 797.067 1462.8 796.24C1460.91 795.413 1459.45 794.173 1458.44 792.52C1457.43 790.867 1456.92 788.813 1456.92 786.36V769.52H1464.12V786.2C1464.12 787.96 1464.59 789.347 1465.52 790.36C1466.45 791.373 1467.83 791.88 1469.64 791.88C1471.45 791.88 1472.84 791.373 1473.8 790.36C1474.76 789.347 1475.24 787.96 1475.24 786.2V769.52H1482.4V786.36C1482.4 788.813 1481.89 790.867 1480.88 792.52C1479.87 794.173 1478.41 795.413 1476.52 796.24C1474.63 797.067 1472.33 797.48 1469.64 797.48ZM1495.21 797V775.4H1486.29V769.52H1511.29V775.4H1502.37V797H1495.21Z"
            fill="#292A39"
            fill-opacity="0.25"
          />
          <path
            id="AZ"
            d="M1473.32 1226L1483.64 1198.52H1492.24L1502.56 1226H1494.92L1493.28 1221.24H1482.32L1480.68 1226H1473.32ZM1484.04 1215.88H1491.52L1489.56 1210.08C1489.45 1209.79 1489.32 1209.43 1489.16 1209C1489.03 1208.55 1488.88 1208.08 1488.72 1207.6C1488.59 1207.09 1488.45 1206.59 1488.32 1206.08C1488.19 1205.57 1488.05 1205.13 1487.92 1204.76H1487.64C1487.53 1205.27 1487.37 1205.84 1487.16 1206.48C1486.97 1207.12 1486.77 1207.76 1486.56 1208.4C1486.37 1209.04 1486.2 1209.6 1486.04 1210.08L1484.04 1215.88ZM1503.88 1226V1223.32L1517.52 1204.12H1504.88V1198.52H1528.44V1201.2L1514.8 1220.4H1528.76V1226H1503.88Z"
            fill="#292A39"
            fill-opacity="0.25"
          />
          <path
            id="NM"
            d="M1881 1215V1187.52H1887.36L1897.36 1200.28C1897.55 1200.49 1897.79 1200.8 1898.08 1201.2C1898.4 1201.6 1898.71 1202.01 1899 1202.44C1899.29 1202.84 1899.51 1203.16 1899.64 1203.4L1899.84 1203.36C1899.84 1202.77 1899.84 1202.21 1899.84 1201.68C1899.84 1201.12 1899.84 1200.65 1899.84 1200.28V1187.52H1906.48V1215H1900.16L1889.56 1201.56C1889.21 1201.13 1888.88 1200.69 1888.56 1200.24C1888.27 1199.79 1888.03 1199.41 1887.84 1199.12L1887.64 1199.16C1887.64 1199.59 1887.64 1200.03 1887.64 1200.48C1887.64 1200.91 1887.64 1201.27 1887.64 1201.56V1215H1881ZM1912.48 1215V1187.52H1922.92L1926.24 1199.76C1926.38 1200.19 1926.54 1200.77 1926.72 1201.52C1926.91 1202.24 1927.1 1203 1927.28 1203.8C1927.47 1204.6 1927.63 1205.32 1927.76 1205.96H1928.08C1928.19 1205.45 1928.32 1204.85 1928.48 1204.16C1928.64 1203.44 1928.82 1202.69 1929 1201.92C1929.19 1201.12 1929.36 1200.39 1929.52 1199.72L1932.88 1187.52H1943.04V1215H1936.08V1203.28C1936.08 1202.13 1936.08 1200.97 1936.08 1199.8C1936.11 1198.63 1936.14 1197.56 1936.16 1196.6C1936.19 1195.64 1936.2 1194.95 1936.2 1194.52H1935.88C1935.8 1194.92 1935.67 1195.51 1935.48 1196.28C1935.32 1197.03 1935.14 1197.81 1934.92 1198.64C1934.74 1199.44 1934.56 1200.13 1934.4 1200.72L1930.4 1215H1924.64L1920.6 1200.72C1920.47 1200.19 1920.31 1199.55 1920.12 1198.8C1919.94 1198.05 1919.75 1197.29 1919.56 1196.52C1919.4 1195.75 1919.26 1195.09 1919.12 1194.56H1918.8C1918.83 1195.25 1918.86 1196.11 1918.88 1197.12C1918.91 1198.11 1918.94 1199.15 1918.96 1200.24C1918.99 1201.31 1919 1202.32 1919 1203.28V1215H1912.48Z"
            fill="#292A39"
            fill-opacity="0.25"
          />
          <path
            id="CO"
            d="M1893.64 812.48C1890.68 812.48 1888.16 811.973 1886.08 810.96C1884.03 809.92 1882.47 808.347 1881.4 806.24C1880.33 804.133 1879.8 801.467 1879.8 798.24C1879.8 793.493 1880.99 789.947 1883.36 787.6C1885.76 785.227 1889.19 784.04 1893.64 784.04C1896.12 784.04 1898.32 784.467 1900.24 785.32C1902.16 786.147 1903.65 787.4 1904.72 789.08C1905.81 790.733 1906.36 792.8 1906.36 795.28H1899.36C1899.36 794.107 1899.12 793.107 1898.64 792.28C1898.19 791.427 1897.53 790.773 1896.68 790.32C1895.85 789.867 1894.84 789.64 1893.64 789.64C1892.15 789.64 1890.92 789.947 1889.96 790.56C1889 791.173 1888.29 792.053 1887.84 793.2C1887.39 794.347 1887.16 795.733 1887.16 797.36V799.16C1887.16 800.787 1887.39 802.187 1887.84 803.36C1888.29 804.507 1888.99 805.387 1889.92 806C1890.88 806.587 1892.11 806.88 1893.6 806.88C1894.88 806.88 1895.96 806.667 1896.84 806.24C1897.75 805.813 1898.43 805.187 1898.88 804.36C1899.36 803.507 1899.6 802.493 1899.6 801.32H1906.36C1906.36 803.8 1905.83 805.867 1904.76 807.52C1903.72 809.173 1902.24 810.413 1900.32 811.24C1898.43 812.067 1896.2 812.48 1893.64 812.48ZM1924.28 812.48C1921.26 812.48 1918.68 811.96 1916.52 810.92C1914.38 809.853 1912.74 808.267 1911.6 806.16C1910.45 804.053 1909.88 801.413 1909.88 798.24C1909.88 795.067 1910.45 792.44 1911.6 790.36C1912.74 788.253 1914.38 786.68 1916.52 785.64C1918.68 784.573 1921.26 784.04 1924.28 784.04C1927.29 784.04 1929.86 784.573 1932 785.64C1934.16 786.68 1935.81 788.253 1936.96 790.36C1938.1 792.44 1938.68 795.067 1938.68 798.24C1938.68 801.413 1938.1 804.053 1936.96 806.16C1935.81 808.267 1934.16 809.853 1932 810.92C1929.86 811.96 1927.29 812.48 1924.28 812.48ZM1924.28 806.88C1925.42 806.88 1926.44 806.707 1927.32 806.36C1928.2 806.013 1928.93 805.507 1929.52 804.84C1930.13 804.173 1930.58 803.36 1930.88 802.4C1931.17 801.44 1931.32 800.36 1931.32 799.16V797.4C1931.32 796.173 1931.17 795.08 1930.88 794.12C1930.58 793.16 1930.13 792.347 1929.52 791.68C1928.93 791.013 1928.2 790.507 1927.32 790.16C1926.44 789.813 1925.42 789.64 1924.28 789.64C1923.1 789.64 1922.08 789.813 1921.2 790.16C1920.32 790.507 1919.58 791.013 1919 791.68C1918.41 792.347 1917.97 793.16 1917.68 794.12C1917.38 795.08 1917.24 796.173 1917.24 797.4V799.16C1917.24 800.36 1917.38 801.44 1917.68 802.4C1917.97 803.36 1918.41 804.173 1919 804.84C1919.58 805.507 1920.32 806.013 1921.2 806.36C1922.08 806.707 1923.1 806.88 1924.28 806.88Z"
            fill="#292A39"
          />
          <g
            id="santa-rosa-1"
            filter="url(#filter5_dddddd_34_304)"
            onMouseEnter={(e) => {
              setTooltipParams({
                x: e.pageX,
                y: e.pageY,
                site: "",
                mouseOnLoc: true,
                api_key: "",
                location: locations[3],
              });
            }}
            onMouseLeave={() =>
              setTooltipParams((ps) => ({ ...ps, mouseOnLoc: false }))
            }
            onClick={() => setActive(locations[3])}
          >
            <circle cx="680" cy="737" r="50" fill="#3D3D56" />
          </g>
          <g
            id="santa-rosa-2"
            filter="url(#filter6_dddddd_34_304)"
            onMouseEnter={(e) => {
              setTooltipParams({
                x: e.pageX,
                y: e.pageY,
                site: "",
                mouseOnLoc: true,
                api_key: "",
                location: locations[4],
              });
            }}
            onMouseLeave={() =>
              setTooltipParams((ps) => ({ ...ps, mouseOnLoc: false }))
            }
            onClick={() => setActive(locations[4])}
          >
            <circle cx="788" cy="727" r="50" fill="#3D3D56" />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_dddddd_34_304"
            x="0.661194"
            y="0.161194"
            width="2552.18"
            height="1941.68"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="8.06356" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.380392 0 0 0 0 0.807843 0 0 0 0 0.839216 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="16.1271" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.380392 0 0 0 0 0.807843 0 0 0 0 0.839216 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_34_304"
              result="effect2_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="56.4449" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.380392 0 0 0 0 0.807843 0 0 0 0 0.839216 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_34_304"
              result="effect3_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="112.89" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.380392 0 0 0 0 0.807843 0 0 0 0 0.839216 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect3_dropShadow_34_304"
              result="effect4_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="193.525" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.380392 0 0 0 0 0.807843 0 0 0 0 0.839216 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect4_dropShadow_34_304"
              result="effect5_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="338.669" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.380392 0 0 0 0 0.807843 0 0 0 0 0.839216 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect5_dropShadow_34_304"
              result="effect6_dropShadow_34_304"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect6_dropShadow_34_304"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_dddddd_34_304"
            x="844.791"
            y="1068.79"
            width="172.418"
            height="172.418"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="0.431058" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="0.862116" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_34_304"
              result="effect2_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="3.0174" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_34_304"
              result="effect3_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="6.03481" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect3_dropShadow_34_304"
              result="effect4_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="10.3454" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect4_dropShadow_34_304"
              result="effect5_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="18.1044" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect5_dropShadow_34_304"
              result="effect6_dropShadow_34_304"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect6_dropShadow_34_304"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_dddddd_34_304"
            x="916.167"
            y="1129.17"
            width="175.391"
            height="173.666"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="0.43849" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="0.87698" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_34_304"
              result="effect2_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="3.06943" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_34_304"
              result="effect3_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="6.13886" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect3_dropShadow_34_304"
              result="effect4_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="10.5238" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect4_dropShadow_34_304"
              result="effect5_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="18.4166" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect5_dropShadow_34_304"
              result="effect6_dropShadow_34_304"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect6_dropShadow_34_304"
              result="shape"
            />
          </filter>
          <filter
            id="filter3_dddddd_34_304"
            x="998.167"
            y="1203.17"
            width="175.391"
            height="173.666"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="0.43849" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="0.87698" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_34_304"
              result="effect2_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="3.06943" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_34_304"
              result="effect3_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="6.13886" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect3_dropShadow_34_304"
              result="effect4_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="10.5238" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect4_dropShadow_34_304"
              result="effect5_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="18.4166" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect5_dropShadow_34_304"
              result="effect6_dropShadow_34_304"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect6_dropShadow_34_304"
              result="shape"
            />
          </filter>
          <filter
            id="filter4_dddddd_34_304"
            x="1783.17"
            y="594.167"
            width="175.391"
            height="173.666"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="0.43849" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="0.87698" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_34_304"
              result="effect2_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="3.06943" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_34_304"
              result="effect3_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="6.13886" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect3_dropShadow_34_304"
              result="effect4_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="10.5238" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect4_dropShadow_34_304"
              result="effect5_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="18.4166" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect5_dropShadow_34_304"
              result="effect6_dropShadow_34_304"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect6_dropShadow_34_304"
              result="shape"
            />
          </filter>
          <filter
            id="filter5_dddddd_34_304"
            x="593.167"
            y="650.167"
            width="173.666"
            height="173.666"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="0.43849" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="0.87698" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_34_304"
              result="effect2_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="3.06943" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_34_304"
              result="effect3_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="6.13886" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect3_dropShadow_34_304"
              result="effect4_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="10.5238" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect4_dropShadow_34_304"
              result="effect5_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="18.4166" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect5_dropShadow_34_304"
              result="effect6_dropShadow_34_304"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect6_dropShadow_34_304"
              result="shape"
            />
          </filter>
          <filter
            id="filter6_dddddd_34_304"
            x="701.167"
            y="640.167"
            width="173.666"
            height="173.666"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="0.43849" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="0.87698" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_34_304"
              result="effect2_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="3.06943" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_34_304"
              result="effect3_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="6.13886" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect3_dropShadow_34_304"
              result="effect4_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="10.5238" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect4_dropShadow_34_304"
              result="effect5_dropShadow_34_304"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="18.4166" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect5_dropShadow_34_304"
              result="effect6_dropShadow_34_304"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect6_dropShadow_34_304"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_34_304"
            x1="1395.32"
            y1="959.618"
            x2="1476.95"
            y2="1528.66"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#41435C" />
            <stop offset="1" stop-color="#38394E" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_34_304"
            x1="1840.88"
            y1="948.414"
            x2="1915.95"
            y2="1471.79"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#41435C" />
            <stop offset="1" stop-color="#38394E" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_34_304"
            x1="1867.88"
            y1="930.414"
            x2="1942.95"
            y2="1453.79"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#5C5E7F" />
            <stop offset="1" stop-color="#666788" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_34_304"
            x1="1867.88"
            y1="930.414"
            x2="1942.95"
            y2="1453.79"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#8688AC" />
            <stop offset="1" stop-color="#444667" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_34_304"
            x1="835.273"
            y1="410.648"
            x2="978.349"
            y2="1408.02"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#41435B" />
            <stop offset="1" stop-color="#38384D" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_34_304"
            x1="1422.7"
            y1="943.314"
            x2="1504.33"
            y2="1512.36"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#5B5D7E" />
            <stop offset="1" stop-color="#666788" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_34_304"
            x1="1422.7"
            y1="943.314"
            x2="1504.33"
            y2="1512.36"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#8D8FB4" />
            <stop offset="1" stop-color="#434566" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_34_304"
            x1="865.273"
            y1="394.648"
            x2="1008.35"
            y2="1392.02"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#5B5D7E" />
            <stop offset="1" stop-color="#666788" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_34_304"
            x1="865.273"
            y1="394.648"
            x2="1008.35"
            y2="1392.02"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#8D8FB4" />
            <stop offset="1" stop-color="#434566" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_34_304"
            x1="1879.93"
            y1="556.48"
            x2="1937.3"
            y2="956.417"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#5B5D7E" />
            <stop offset="1" stop-color="#666788" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_34_304"
            x1="1879.93"
            y1="556.48"
            x2="1937.3"
            y2="956.417"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#8D8FB4" />
            <stop offset="1" stop-color="#434566" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_34_304"
            x1="1067.76"
            y1="444.968"
            x2="1170.11"
            y2="1158.44"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#5B5D7E" />
            <stop offset="1" stop-color="#666788" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_34_304"
            x1="1067.76"
            y1="444.968"
            x2="1170.11"
            y2="1158.44"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#8D8FB4" />
            <stop offset="1" stop-color="#434566" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_34_304"
            x1="1436.53"
            y1="477.73"
            x2="1509.13"
            y2="983.824"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#5B5D7E" />
            <stop offset="1" stop-color="#666788" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_34_304"
            x1="1436.53"
            y1="477.73"
            x2="1509.13"
            y2="983.824"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#8D8FB4" />
            <stop offset="1" stop-color="#434566" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="main-map"
      viewBox="0 0 2553 1942"
      fill="none"
    >
      <g id="map">
        <path
          id="Arizona"
          d="M1632.38 976.326L1482.14 979.029L1401.23 978.967L1285.64 977.147L1274 977.021L1274.13 977.901L1267.1 1065.98L1256.96 1066.98L1239.68 1055.55L1222.74 1074.59L1232.33 1144.57L1227.47 1160.53L1227.66 1161.85L1227.72 1162.29L1228.42 1173.41L1249.68 1212.54L1265.91 1229.07L1243.46 1247.1L1236.42 1266.51L1226.2 1307.47L1218.57 1310.36L1222.74 1342.52L1237.76 1350.69L1233.53 1371.05L1217.89 1374.19L1211.15 1392.66L1245.53 1407.92L1309.88 1432.8L1507.9 1504.48L1666.59 1501.46L1668.34 1501.21L1662 1369.72L1660.46 1337.18L1644.48 992.095L1643.96 976.012L1632.38 976.326Z"
          fill="url(#paint0_linear_18_279)"
        />
        <path
          id="New Mexico"
          d="M2095.88 979.05L2094.68 967.571L2093.48 956.092L2092.29 944.613L2078.17 946.19L1980.45 955.726L1882.05 963.568L1657.88 976.009L1644.08 976.645L1644.59 992.704L1660.39 1337.27L1661.92 1369.77L1668.2 1501.06L1670.02 1501.24L1731.46 1498.26L1732.76 1466.7L1742.48 1456.34L1867.05 1449.68L1867.93 1449.55L1853.86 1429.61L1910.22 1425.56L2050.6 1413.49L2138.15 1404.96L2094 990.97L2097.14 990.968L2095.88 979.05Z"
          fill="url(#paint1_linear_18_279)"
        />
        <path
          id="New Mexico_2"
          d="M2122.88 961.05L2121.68 949.571L2120.48 938.092L2119.29 926.613L2105.17 928.19L2007.45 937.726L1909.05 945.568L1684.88 958.009L1671.08 958.645L1671.59 974.704L1687.39 1319.27L1688.92 1351.77L1695.2 1483.06L1697.02 1483.24L1758.46 1480.26L1759.76 1448.7L1769.48 1438.34L1894.05 1431.68L1894.93 1431.55L1880.86 1411.61L1937.22 1407.56L2077.6 1395.49L2165.15 1386.96L2121 972.97L2124.14 972.968L2122.88 961.05Z"
          fill="url(#paint2_linear_18_279)"
          stroke="url(#paint3_linear_18_279)"
          strokeWidth="4"
          strokeLinejoin="round"
        />
        <path
          id="California"
          d="M913.739 1328.06L916.883 1337.47L917.135 1339.23L913.739 1328.06ZM843.729 1299.54L847.75 1305.69L849.445 1304.99L843.729 1299.54ZM920.432 1287.19L923.389 1298.42L932.117 1303L920.432 1287.19ZM858.317 1232.42L853.294 1231.8L857.501 1232.99L858.317 1232.42ZM807.654 1226.24L796.799 1234.97L800.316 1237.61L807.654 1226.24ZM783.609 1221.17L783.234 1224.81L787.315 1225.12L783.609 1221.17ZM823.535 1224.41L844.444 1232.62L847.517 1229.04L823.535 1224.41ZM665.506 854.269L664.877 853.014L665.129 854.771L665.506 854.269ZM871.192 484.417L853.425 482.481L657.932 457.612L585.044 446.544L585.296 448.302L587.582 492.367L576.502 546.421L551.229 589.058L553.123 608.517L571.907 633.175L584.419 667.253L577.97 697.325L583.825 725.633L580.254 738.252L603.878 774.772L617.445 788.072L622.68 830.817L653.641 852.832L665.677 824.201L684.767 835.363L690.475 828.266L667.379 836.064L670.154 858.535L679.021 885.961L664.011 875.11L654.084 859.046L655.29 883.087L668.186 929.218L697.14 956.005L683.908 979.427L690.389 1005.85L711.873 1030.57L754.731 1110.52L765.154 1114.4L770.461 1173.28L776.302 1179.62L845.614 1193.89L868.914 1212.52L877.961 1225.57L898.869 1233.78L920.527 1234.71L932.781 1257.62L951.554 1263.44L982.392 1290.86L1012.86 1328.19L1016.52 1366.23L1032.73 1382.29L1214.96 1374.08L1230.65 1370.93L1234.91 1350.59L1219.83 1342.44L1215.67 1310.3L1223.33 1307.41L1233.6 1266.48L1240.68 1247.08L1263.21 1229.05L1246.94 1212.55L1225.64 1173.45L1224.94 1162.34L1224.88 1161.9L1211.25 1148.16L1169.35 1106.19L1087.51 1020.18L973.063 897.59L908.806 831.026L846.244 763.77L869.632 501.68L871.192 484.417Z"
          fill="url(#paint4_linear_18_279)"
        />
        <path
          id="Arizona_2"
          d="M1659.76 960.022L1509.51 962.725L1428.6 962.663L1313.02 960.843L1301.38 960.717L1301.5 961.597L1294.47 1049.67L1284.34 1050.68L1267.05 1039.25L1250.12 1058.28L1259.71 1128.27L1254.84 1144.22L1255.03 1145.54L1255.1 1145.98L1255.8 1157.1L1277.06 1196.24L1293.28 1212.76L1270.84 1230.79L1263.79 1250.2L1253.57 1291.16L1245.94 1294.05L1250.11 1326.22L1265.14 1334.39L1260.91 1354.74L1245.27 1357.88L1238.53 1376.35L1272.9 1391.62L1337.26 1416.5L1535.27 1488.17L1693.97 1485.16L1695.72 1484.91L1689.37 1353.42L1687.83 1320.88L1671.85 975.791L1671.33 959.708L1659.76 960.022Z"
          fill="url(#paint5_linear_18_279)"
          stroke="url(#paint6_linear_18_279)"
          strokeWidth="4"
          strokeLinejoin="round"
        />
        <g id="California_2">
          <path
            d="M943.739 1312.06L946.883 1321.47L947.135 1323.23L943.739 1312.06ZM873.729 1283.54L877.75 1289.69L879.445 1288.99L873.729 1283.54ZM950.432 1271.19L953.389 1282.42L962.117 1287L950.432 1271.19ZM888.317 1216.42L883.294 1215.8L887.501 1216.99L888.317 1216.42ZM837.654 1210.24L826.799 1218.97L830.316 1221.61L837.654 1210.24ZM813.609 1205.17L813.234 1208.81L817.315 1209.12L813.609 1205.17ZM853.535 1208.41L874.444 1216.62L877.517 1213.04L853.535 1208.41ZM695.506 838.269L694.877 837.014L695.129 838.771L695.506 838.269ZM901.192 468.417L883.425 466.481L687.932 441.612L615.044 430.544L615.296 432.302L617.582 476.367L606.502 530.421L581.229 573.058L583.123 592.517L601.907 617.175L614.419 651.253L607.97 681.325L613.825 709.633L610.254 722.252L633.878 758.772L647.445 772.072L652.68 814.817L683.641 836.832L695.677 808.201L714.767 819.363L720.475 812.266L697.379 820.064L700.154 842.535L709.021 869.961L694.011 859.11L684.084 843.046L685.29 867.087L698.186 913.218L727.14 940.005L713.908 963.427L720.389 989.85L741.873 1014.57L784.731 1094.52L795.154 1098.4L800.461 1157.28L806.302 1163.62L875.614 1177.89L898.914 1196.52L907.961 1209.57L928.869 1217.78L950.527 1218.71L962.781 1241.62L981.554 1247.44L1012.39 1274.86L1042.86 1312.19L1046.52 1350.23L1062.73 1366.29L1244.96 1358.08L1260.65 1354.93L1264.91 1334.59L1249.83 1326.44L1245.67 1294.3L1253.33 1291.41L1263.6 1250.48L1270.68 1231.08L1293.21 1213.05L1276.94 1196.55L1255.64 1157.45L1254.94 1146.34L1254.88 1145.9L1241.25 1132.16L1199.35 1090.19L1117.51 1004.18L1003.06 881.59L938.806 815.026L876.244 747.77L899.632 485.68L901.192 468.417Z"
            fill="url(#paint7_linear_18_279)"
          />
          <path
            d="M648.177 842.816L647.8 843.319M943.739 1312.06L946.883 1321.47L947.135 1323.23L943.739 1312.06ZM873.729 1283.54L877.75 1289.69L879.445 1288.99L873.729 1283.54ZM950.432 1271.19L953.389 1282.42L962.117 1287L950.432 1271.19ZM888.317 1216.42L883.294 1215.8L887.501 1216.99L888.317 1216.42ZM837.654 1210.24L826.799 1218.97L830.316 1221.61L837.654 1210.24ZM813.609 1205.17L813.234 1208.81L817.315 1209.12L813.609 1205.17ZM853.535 1208.41L874.444 1216.62L877.517 1213.04L853.535 1208.41ZM695.506 838.269L694.877 837.014L695.129 838.771L695.506 838.269ZM901.192 468.417L883.425 466.481L687.932 441.612L615.044 430.544L615.296 432.302L617.582 476.367L606.502 530.421L581.229 573.058L583.123 592.517L601.907 617.175L614.419 651.253L607.97 681.325L613.825 709.633L610.254 722.252L633.878 758.772L647.445 772.072L652.68 814.817L683.641 836.832L695.677 808.201L714.767 819.363L720.475 812.266L697.379 820.064L700.154 842.535L709.021 869.961L694.011 859.11L684.084 843.046L685.29 867.087L698.186 913.218L727.14 940.005L713.908 963.427L720.389 989.85L741.873 1014.57L784.731 1094.52L795.154 1098.4L800.461 1157.28L806.302 1163.62L875.614 1177.89L898.914 1196.52L907.961 1209.57L928.869 1217.78L950.527 1218.71L962.781 1241.62L981.554 1247.44L1012.39 1274.86L1042.86 1312.19L1046.52 1350.23L1062.73 1366.29L1244.96 1358.08L1260.65 1354.93L1264.91 1334.59L1249.83 1326.44L1245.67 1294.3L1253.33 1291.41L1263.6 1250.48L1270.68 1231.08L1293.21 1213.05L1276.94 1196.55L1255.64 1157.45L1254.94 1146.34L1254.88 1145.9L1241.25 1132.16L1199.35 1090.19L1117.51 1004.18L1003.06 881.59L938.806 815.026L876.244 747.77L899.632 485.68L901.192 468.417Z"
            stroke="url(#paint8_linear_18_279)"
            strokeWidth="4"
            strokeLinejoin="round"
          />
        </g>
        <path
          id="Colorado"
          d="M2156.31 638.253L2145.73 551.955L2124.5 554.103L2016.7 565.536L2006.08 566.61L1997.23 567.432L1865.5 577.816L1777.47 583.276L1667.4 588.312L1656.66 588.508L1656.98 600.112L1666.06 832.24L1669.17 913.337L1670.63 948.524L1671.38 960.064L1685.2 959.426L1909.48 946.966L2007.94 939.115L2105.7 929.572L2119.83 927.993L2128.68 927.172L2147.2 924.963L2156.06 924.141L2183.87 921.047L2190.9 920.038L2189.64 911.258L2161.16 678.329L2157.89 652.364L2156.69 644.023L2156.31 638.253Z"
          fill="url(#paint9_linear_18_279)"
          stroke="url(#paint10_linear_18_279)"
          strokeWidth="4"
          strokeLinejoin="round"
        />
        <path
          id="Nevada"
          d="M1301.67 947.213L1306.58 656.414L1309.45 510.731L1310.07 496.294L1297.01 495.925L1246.05 493.821L1118.18 487.054L1105.5 486.183L1092.83 485.312L1028.93 480.579L913.993 470.164L901.25 468.853L899.691 486.115L876.306 748.178L938.861 815.427L1003.11 881.985L1117.54 1004.56L1199.38 1090.57L1241.27 1132.54L1254.9 1146.27L1254.71 1144.95L1259.6 1129.01L1250.01 1059.09L1267.01 1040.06L1284.34 1051.48L1294.51 1050.47L1301.62 962.466L1301.49 961.587L1301.67 947.213Z"
          fill="url(#paint11_linear_18_279)"
          stroke="url(#paint12_linear_18_279)"
          strokeWidth="4"
          strokeLinejoin="round"
        />
        <path
          id="Utah"
          d="M1502.65 498.312L1386.95 497.409L1322.29 496.363L1309.69 495.927L1309.07 510.375L1306.24 656.175L1301.41 947.208L1301.23 961.594L1312.89 961.715L1428.72 963.498L1509.81 963.534L1660.37 960.783L1671.97 960.465L1671.21 948.907L1669.74 913.667L1666.6 832.445L1657.44 599.962L1657.11 588.341L1648.21 588.721L1534.33 591.146L1516.9 591.403L1515.57 504.087L1515.63 498.245L1502.65 498.312Z"
          fill="url(#paint13_linear_18_279)"
          stroke="url(#paint14_linear_18_279)"
          strokeWidth="4"
          strokeLinejoin="round"
        />
        <g id="grid-line" filter="url(#filter0_dddddd_18_279)">
          <path
            d="M1873.5 679.5L680 726.6L931.5 1181.5L993.5 1210L1046 1262.5L1873.5 679.5Z"
            stroke="#00CFDD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="20 20"
            className="dash"
          />
        </g>
        <g
          id="ventura-1"
          filter="url(#filter1_dddddd_18_279)"
          onMouseEnter={(e) => {
            setTooltipParams({
              x: e.pageX,
              y: e.pageY,
              site: "3216399",
              mouseOnLoc: true,
              api_key: "XVRME06UVZZ8Z4YSKDOLAWPN0QPEUF41",
              location: locations[1],
            });
          }}
          onMouseLeave={() =>
            setTooltipParams((ps) => ({ ...ps, mouseOnLoc: false }))
          }
          onClick={() => setActive(locations[1])}
        >
          <circle
            cx="934"
            cy={isMobile ? 1160 : 1180}
            r={cirlceRadius}
            fill="#3D3D56"
          />
        </g>
        <g
          id="ventura-2"
          filter="url(#filter2_dddddd_18_279)"
          onMouseEnter={(e) => {
            setTooltipParams({
              x: e.pageX,
              y: e.pageY,
              site: "2140795",
              mouseOnLoc: true,
              api_key: "TAIZZC11OHF8SR4RIA3KYLM1NZ4Y7U6T",
              location: locations[2],
            });
          }}
          onMouseLeave={() =>
            setTooltipParams((ps) => ({ ...ps, mouseOnLoc: false }))
          }
          onClick={() => setActive(locations[2])}
        >
          <circle cx="992.5" cy="1209" r={cirlceRadius} fill="#3D3D56" />
        </g>
        <g
          id="malibu"
          filter="url(#filter3_dddddd_18_279)"
          onMouseEnter={(e) => {
            setTooltipParams({
              x: e.pageX,
              y: e.pageY,
              site: "2048560",
              mouseOnLoc: true,
              api_key: "P1GNDFIMMHTOL883T16PQSYS8ILLRE5J",
              location: locations[0],
            });
          }}
          onMouseLeave={() =>
            setTooltipParams((ps) => ({ ...ps, mouseOnLoc: false }))
          }
          onClick={() => setActive(locations[0])}
        >
          <circle cx="1045.5" cy="1261" r={cirlceRadius} fill="#3D3D56" />
        </g>
        <g
          id="colorado"
          filter="url(#filter4_dddddd_18_279)"
          onMouseEnter={(e) => {
            setTooltipParams({
              x: e.pageX,
              y: e.pageY,
              site: "1639176",
              mouseOnLoc: true,
              api_key: "KW0CIBOR7XLQX6CYFNJHHL5NMRHJYMN8",
              location: locations[5],
            });
          }}
          onMouseLeave={() =>
            setTooltipParams((ps) => ({ ...ps, mouseOnLoc: false }))
          }
          onClick={() => setActive(locations[5])}
        >
          <circle cx="1873.5" cy="679" r={cirlceRadius} fill="#3D3D56" />
        </g>
        <g
          id="santa-rosa-1"
          filter="url(#filter5_dddddd_18_279)"
          onMouseEnter={(e) => {
            setTooltipParams({
              x: e.pageX,
              y: e.pageY,
              site: "",
              mouseOnLoc: true,
              api_key: "",
              location: locations[3],
            });
          }}
          onMouseLeave={() =>
            setTooltipParams((ps) => ({ ...ps, mouseOnLoc: false }))
          }
          onClick={() => setActive(locations[3])}
        >
          <circle
            cx={isMobile ? 682.5 : 692.5}
            cy="731.5"
            r={cirlceRadius}
            fill="#3D3D56"
          />
        </g>
        <g
          id="santa-rosa-2"
          filter="url(#filter6_dddddd_18_279)"
          onMouseEnter={(e) => {
            setTooltipParams({
              x: e.pageX,
              y: e.pageY,
              site: "",
              mouseOnLoc: true,
              api_key: "",
              location: locations[4],
            });
          }}
          onMouseLeave={() =>
            setTooltipParams((ps) => ({ ...ps, mouseOnLoc: false }))
          }
          onClick={() => setActive(locations[4])}
        >
          <circle
            cx={isMobile ? 780.5 : 760.5}
            cy="725.5"
            r={cirlceRadius}
            fill="#3D3D56"
          />
        </g>
      </g>
      <path
        id="CA"
        d="M908.64 1004.48C905.68 1004.48 903.16 1003.97 901.08 1002.96C899.027 1001.92 897.467 1000.35 896.4 998.24C895.333 996.133 894.8 993.467 894.8 990.24C894.8 985.493 895.987 981.947 898.36 979.6C900.76 977.227 904.187 976.04 908.64 976.04C911.12 976.04 913.32 976.467 915.24 977.32C917.16 978.147 918.653 979.4 919.72 981.08C920.813 982.733 921.36 984.8 921.36 987.28H914.36C914.36 986.107 914.12 985.107 913.64 984.28C913.187 983.427 912.533 982.773 911.68 982.32C910.853 981.867 909.84 981.64 908.64 981.64C907.147 981.64 905.92 981.947 904.96 982.56C904 983.173 903.293 984.053 902.84 985.2C902.387 986.347 902.16 987.733 902.16 989.36V991.16C902.16 992.787 902.387 994.187 902.84 995.36C903.293 996.507 903.987 997.387 904.92 998C905.88 998.587 907.107 998.88 908.6 998.88C909.88 998.88 910.96 998.667 911.84 998.24C912.747 997.813 913.427 997.187 913.88 996.36C914.36 995.507 914.6 994.493 914.6 993.32H921.36C921.36 995.8 920.827 997.867 919.76 999.52C918.72 1001.17 917.24 1002.41 915.32 1003.24C913.427 1004.07 911.2 1004.48 908.64 1004.48ZM922.968 1004L933.288 976.52H941.888L952.208 1004H944.568L942.928 999.24H931.968L930.328 1004H922.968ZM933.688 993.88H941.168L939.208 988.08C939.102 987.787 938.968 987.427 938.808 987C938.675 986.547 938.528 986.08 938.368 985.6C938.235 985.093 938.102 984.587 937.968 984.08C937.835 983.573 937.702 983.133 937.568 982.76H937.288C937.182 983.267 937.022 983.84 936.808 984.48C936.622 985.12 936.422 985.76 936.208 986.4C936.022 987.04 935.848 987.6 935.688 988.08L933.688 993.88Z"
        fill="#292A39"
        fill-opacity="0.75"
      />
      <path
        id="NV"
        d="M1078 777V749.52H1084.36L1094.36 762.28C1094.55 762.493 1094.79 762.8 1095.08 763.2C1095.4 763.6 1095.71 764.013 1096 764.44C1096.29 764.84 1096.51 765.16 1096.64 765.4L1096.84 765.36C1096.84 764.773 1096.84 764.213 1096.84 763.68C1096.84 763.12 1096.84 762.653 1096.84 762.28V749.52H1103.48V777H1097.16L1086.56 763.56C1086.21 763.133 1085.88 762.693 1085.56 762.24C1085.27 761.787 1085.03 761.413 1084.84 761.12L1084.64 761.16C1084.64 761.587 1084.64 762.027 1084.64 762.48C1084.64 762.907 1084.64 763.267 1084.64 763.56V777H1078ZM1116.92 777L1107.04 749.52H1114.72L1119.76 765.04C1119.87 765.36 1120 765.787 1120.16 766.32C1120.32 766.827 1120.48 767.36 1120.64 767.92C1120.83 768.453 1120.98 768.933 1121.08 769.36H1121.36C1121.5 768.96 1121.63 768.507 1121.76 768C1121.92 767.467 1122.08 766.947 1122.24 766.44C1122.4 765.907 1122.54 765.453 1122.64 765.08L1127.68 749.52H1135.08L1125.24 777H1116.92Z"
        fill="#292A39"
        fill-opacity="0.25"
      />
      <path
        id="UT"
        d="M1469.64 797.48C1467 797.48 1464.72 797.067 1462.8 796.24C1460.91 795.413 1459.45 794.173 1458.44 792.52C1457.43 790.867 1456.92 788.813 1456.92 786.36V769.52H1464.12V786.2C1464.12 787.96 1464.59 789.347 1465.52 790.36C1466.45 791.373 1467.83 791.88 1469.64 791.88C1471.45 791.88 1472.84 791.373 1473.8 790.36C1474.76 789.347 1475.24 787.96 1475.24 786.2V769.52H1482.4V786.36C1482.4 788.813 1481.89 790.867 1480.88 792.52C1479.87 794.173 1478.41 795.413 1476.52 796.24C1474.63 797.067 1472.33 797.48 1469.64 797.48ZM1495.21 797V775.4H1486.29V769.52H1511.29V775.4H1502.37V797H1495.21Z"
        fill="#292A39"
        fill-opacity="0.25"
      />
      <path
        id="AZ"
        d="M1473.32 1226L1483.64 1198.52H1492.24L1502.56 1226H1494.92L1493.28 1221.24H1482.32L1480.68 1226H1473.32ZM1484.04 1215.88H1491.52L1489.56 1210.08C1489.45 1209.79 1489.32 1209.43 1489.16 1209C1489.03 1208.55 1488.88 1208.08 1488.72 1207.6C1488.59 1207.09 1488.45 1206.59 1488.32 1206.08C1488.19 1205.57 1488.05 1205.13 1487.92 1204.76H1487.64C1487.53 1205.27 1487.37 1205.84 1487.16 1206.48C1486.97 1207.12 1486.77 1207.76 1486.56 1208.4C1486.37 1209.04 1486.2 1209.6 1486.04 1210.08L1484.04 1215.88ZM1503.88 1226V1223.32L1517.52 1204.12H1504.88V1198.52H1528.44V1201.2L1514.8 1220.4H1528.76V1226H1503.88Z"
        fill="#292A39"
        fill-opacity="0.25"
      />
      <path
        id="NM"
        d="M1881 1215V1187.52H1887.36L1897.36 1200.28C1897.55 1200.49 1897.79 1200.8 1898.08 1201.2C1898.4 1201.6 1898.71 1202.01 1899 1202.44C1899.29 1202.84 1899.51 1203.16 1899.64 1203.4L1899.84 1203.36C1899.84 1202.77 1899.84 1202.21 1899.84 1201.68C1899.84 1201.12 1899.84 1200.65 1899.84 1200.28V1187.52H1906.48V1215H1900.16L1889.56 1201.56C1889.21 1201.13 1888.88 1200.69 1888.56 1200.24C1888.27 1199.79 1888.03 1199.41 1887.84 1199.12L1887.64 1199.16C1887.64 1199.59 1887.64 1200.03 1887.64 1200.48C1887.64 1200.91 1887.64 1201.27 1887.64 1201.56V1215H1881ZM1912.48 1215V1187.52H1922.92L1926.24 1199.76C1926.38 1200.19 1926.54 1200.77 1926.72 1201.52C1926.91 1202.24 1927.1 1203 1927.28 1203.8C1927.47 1204.6 1927.63 1205.32 1927.76 1205.96H1928.08C1928.19 1205.45 1928.32 1204.85 1928.48 1204.16C1928.64 1203.44 1928.82 1202.69 1929 1201.92C1929.19 1201.12 1929.36 1200.39 1929.52 1199.72L1932.88 1187.52H1943.04V1215H1936.08V1203.28C1936.08 1202.13 1936.08 1200.97 1936.08 1199.8C1936.11 1198.63 1936.14 1197.56 1936.16 1196.6C1936.19 1195.64 1936.2 1194.95 1936.2 1194.52H1935.88C1935.8 1194.92 1935.67 1195.51 1935.48 1196.28C1935.32 1197.03 1935.14 1197.81 1934.92 1198.64C1934.74 1199.44 1934.56 1200.13 1934.4 1200.72L1930.4 1215H1924.64L1920.6 1200.72C1920.47 1200.19 1920.31 1199.55 1920.12 1198.8C1919.94 1198.05 1919.75 1197.29 1919.56 1196.52C1919.4 1195.75 1919.26 1195.09 1919.12 1194.56H1918.8C1918.83 1195.25 1918.86 1196.11 1918.88 1197.12C1918.91 1198.11 1918.94 1199.15 1918.96 1200.24C1918.99 1201.31 1919 1202.32 1919 1203.28V1215H1912.48Z"
        fill="#292A39"
        fill-opacity="0.25"
      />
      <path
        id="CO"
        d="M1893.64 812.48C1890.68 812.48 1888.16 811.973 1886.08 810.96C1884.03 809.92 1882.47 808.347 1881.4 806.24C1880.33 804.133 1879.8 801.467 1879.8 798.24C1879.8 793.493 1880.99 789.947 1883.36 787.6C1885.76 785.227 1889.19 784.04 1893.64 784.04C1896.12 784.04 1898.32 784.467 1900.24 785.32C1902.16 786.147 1903.65 787.4 1904.72 789.08C1905.81 790.733 1906.36 792.8 1906.36 795.28H1899.36C1899.36 794.107 1899.12 793.107 1898.64 792.28C1898.19 791.427 1897.53 790.773 1896.68 790.32C1895.85 789.867 1894.84 789.64 1893.64 789.64C1892.15 789.64 1890.92 789.947 1889.96 790.56C1889 791.173 1888.29 792.053 1887.84 793.2C1887.39 794.347 1887.16 795.733 1887.16 797.36V799.16C1887.16 800.787 1887.39 802.187 1887.84 803.36C1888.29 804.507 1888.99 805.387 1889.92 806C1890.88 806.587 1892.11 806.88 1893.6 806.88C1894.88 806.88 1895.96 806.667 1896.84 806.24C1897.75 805.813 1898.43 805.187 1898.88 804.36C1899.36 803.507 1899.6 802.493 1899.6 801.32H1906.36C1906.36 803.8 1905.83 805.867 1904.76 807.52C1903.72 809.173 1902.24 810.413 1900.32 811.24C1898.43 812.067 1896.2 812.48 1893.64 812.48ZM1924.28 812.48C1921.26 812.48 1918.68 811.96 1916.52 810.92C1914.38 809.853 1912.74 808.267 1911.6 806.16C1910.45 804.053 1909.88 801.413 1909.88 798.24C1909.88 795.067 1910.45 792.44 1911.6 790.36C1912.74 788.253 1914.38 786.68 1916.52 785.64C1918.68 784.573 1921.26 784.04 1924.28 784.04C1927.29 784.04 1929.86 784.573 1932 785.64C1934.16 786.68 1935.81 788.253 1936.96 790.36C1938.1 792.44 1938.68 795.067 1938.68 798.24C1938.68 801.413 1938.1 804.053 1936.96 806.16C1935.81 808.267 1934.16 809.853 1932 810.92C1929.86 811.96 1927.29 812.48 1924.28 812.48ZM1924.28 806.88C1925.42 806.88 1926.44 806.707 1927.32 806.36C1928.2 806.013 1928.93 805.507 1929.52 804.84C1930.13 804.173 1930.58 803.36 1930.88 802.4C1931.17 801.44 1931.32 800.36 1931.32 799.16V797.4C1931.32 796.173 1931.17 795.08 1930.88 794.12C1930.58 793.16 1930.13 792.347 1929.52 791.68C1928.93 791.013 1928.2 790.507 1927.32 790.16C1926.44 789.813 1925.42 789.64 1924.28 789.64C1923.1 789.64 1922.08 789.813 1921.2 790.16C1920.32 790.507 1919.58 791.013 1919 791.68C1918.41 792.347 1917.97 793.16 1917.68 794.12C1917.38 795.08 1917.24 796.173 1917.24 797.4V799.16C1917.24 800.36 1917.38 801.44 1917.68 802.4C1917.97 803.36 1918.41 804.173 1919 804.84C1919.58 805.507 1920.32 806.013 1921.2 806.36C1922.08 806.707 1923.1 806.88 1924.28 806.88Z"
        fill="#292A39"
        fill-opacity="0.75"
      />

      <defs>
        <filter
          id="filter0_dddddd_18_279"
          x="0.661194"
          y="0.161194"
          width="2552.18"
          height="1941.68"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8.06356" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.380392 0 0 0 0 0.807843 0 0 0 0 0.839216 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="16.1271" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.380392 0 0 0 0 0.807843 0 0 0 0 0.839216 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_18_279"
            result="effect2_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="56.4449" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.380392 0 0 0 0 0.807843 0 0 0 0 0.839216 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_18_279"
            result="effect3_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="112.89" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.380392 0 0 0 0 0.807843 0 0 0 0 0.839216 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_18_279"
            result="effect4_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="193.525" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.380392 0 0 0 0 0.807843 0 0 0 0 0.839216 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect4_dropShadow_18_279"
            result="effect5_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="338.669" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.380392 0 0 0 0 0.807843 0 0 0 0 0.839216 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect5_dropShadow_18_279"
            result="effect6_dropShadow_18_279"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect6_dropShadow_18_279"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_dddddd_18_279"
          x="868.791"
          y="1114.79"
          width="130.418"
          height="130.418"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.431058" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.862116" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_18_279"
            result="effect2_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.0174" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_18_279"
            result="effect3_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.03481" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_18_279"
            result="effect4_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10.3454" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect4_dropShadow_18_279"
            result="effect5_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="18.1044" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect5_dropShadow_18_279"
            result="effect6_dropShadow_18_279"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect6_dropShadow_18_279"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_dddddd_18_279"
          x="926.167"
          y="1143.17"
          width="132.666"
          height="131.666"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.43849" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.87698" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_18_279"
            result="effect2_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.06943" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_18_279"
            result="effect3_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.13886" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_18_279"
            result="effect4_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10.5238" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect4_dropShadow_18_279"
            result="effect5_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="18.4166" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect5_dropShadow_18_279"
            result="effect6_dropShadow_18_279"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect6_dropShadow_18_279"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_dddddd_18_279"
          x="979.167"
          y="1195.17"
          width="132.666"
          height="131.666"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.43849" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.87698" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_18_279"
            result="effect2_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.06943" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_18_279"
            result="effect3_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.13886" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_18_279"
            result="effect4_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10.5238" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect4_dropShadow_18_279"
            result="effect5_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="18.4166" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect5_dropShadow_18_279"
            result="effect6_dropShadow_18_279"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect6_dropShadow_18_279"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_dddddd_18_279"
          x="1807.17"
          y="613.167"
          width="132.666"
          height="131.666"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.43849" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.87698" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_18_279"
            result="effect2_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.06943" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_18_279"
            result="effect3_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.13886" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_18_279"
            result="effect4_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10.5238" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect4_dropShadow_18_279"
            result="effect5_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="18.4166" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect5_dropShadow_18_279"
            result="effect6_dropShadow_18_279"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect6_dropShadow_18_279"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_dddddd_18_279"
          x="626.167"
          y="665.167"
          width="132.666"
          height="132.666"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.43849" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.87698" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_18_279"
            result="effect2_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.06943" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_18_279"
            result="effect3_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.13886" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_18_279"
            result="effect4_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10.5238" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect4_dropShadow_18_279"
            result="effect5_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="18.4166" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect5_dropShadow_18_279"
            result="effect6_dropShadow_18_279"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect6_dropShadow_18_279"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_dddddd_18_279"
          x="694.167"
          y="665.167"
          width="132.666"
          height="132.666"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.43849" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.87698" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_18_279"
            result="effect2_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.06943" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_18_279"
            result="effect3_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.13886" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_18_279"
            result="effect4_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10.5238" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect4_dropShadow_18_279"
            result="effect5_dropShadow_18_279"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="18.4166" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.466667 0 0 0 0 0.470588 0 0 0 0 0.572549 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect5_dropShadow_18_279"
            result="effect6_dropShadow_18_279"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect6_dropShadow_18_279"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_18_279"
          x1="1395.32"
          y1="959.618"
          x2="1476.95"
          y2="1528.66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#41435C" />
          <stop offset="1" stopColor="#38394E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_18_279"
          x1="1840.88"
          y1="948.414"
          x2="1915.95"
          y2="1471.79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#41435C" />
          <stop offset="1" stopColor="#38394E" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_18_279"
          x1="1867.88"
          y1="930.414"
          x2="1942.95"
          y2="1453.79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5C5E7F" />
          <stop offset="1" stopColor="#666788" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_18_279"
          x1="1867.88"
          y1="930.414"
          x2="1942.95"
          y2="1453.79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8688AC" />
          <stop offset="1" stopColor="#444667" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_18_279"
          x1="835.273"
          y1="410.648"
          x2="978.349"
          y2="1408.02"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#41435B" />
          <stop offset="1" stopColor="#38384D" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_18_279"
          x1="1422.7"
          y1="943.314"
          x2="1504.33"
          y2="1512.36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5D7E" />
          <stop offset="1" stopColor="#666788" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_18_279"
          x1="1422.7"
          y1="943.314"
          x2="1504.33"
          y2="1512.36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8D8FB4" />
          <stop offset="1" stopColor="#434566" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_18_279"
          x1="865.273"
          y1="394.648"
          x2="1008.35"
          y2="1392.02"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5D7E" />
          <stop offset="1" stopColor="#666788" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_18_279"
          x1="865.273"
          y1="394.648"
          x2="1008.35"
          y2="1392.02"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8D8FB4" />
          <stop offset="1" stopColor="#434566" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_18_279"
          x1="1879.93"
          y1="556.48"
          x2="1937.3"
          y2="956.417"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5D7E" />
          <stop offset="1" stopColor="#666788" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_18_279"
          x1="1879.93"
          y1="556.48"
          x2="1937.3"
          y2="956.417"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8D8FB4" />
          <stop offset="1" stopColor="#434566" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_18_279"
          x1="1067.76"
          y1="444.968"
          x2="1170.11"
          y2="1158.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5D7E" />
          <stop offset="1" stopColor="#666788" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_18_279"
          x1="1067.76"
          y1="444.968"
          x2="1170.11"
          y2="1158.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8D8FB4" />
          <stop offset="1" stopColor="#434566" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_18_279"
          x1="1436.53"
          y1="477.73"
          x2="1509.13"
          y2="983.824"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5B5D7E" />
          <stop offset="1" stopColor="#666788" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_18_279"
          x1="1436.53"
          y1="477.73"
          x2="1509.13"
          y2="983.824"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8D8FB4" />
          <stop offset="1" stopColor="#434566" />
        </linearGradient>
      </defs>
    </svg>
  );
};
